import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import top from '../Assets/tv-top.svg';
import bottom from '../Assets/tv-bottom.svg';
import thum from '../Assets/tham.jpg';
import thum1 from '../Assets/thum1.jpg';
import thum2 from '../Assets/thum2.jpg';
import parant from '../Assets/illustration-people-3.svg';
import { FaQuestion, FaHome, FaRegFilePdf } from 'react-icons/fa';
import { Parallax, ParallaxProvider } from 'react-scroll-parallax';
import { Dialog } from '@mui/material'; 
// Import Dialog from Material-UI

const Happy = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');

  const videoLinks = [
    { thumbnail: thum1, link: 'https://youtu.be/7eIAu6siRxw?si=_Ts3mRFjKKO0bTvy' },
    { thumbnail: thum, link: 'https://youtu.be/e9fNE7WsDj0?si=Coi8EEXeQ0cYbWKq' },
    { thumbnail: thum2, link: 'https://youtu.be/RzkwXdyjtns?si=oYptjHGLEMDJqWM7'}, 
  ];

  const cards = [
    {
      icon: <FaQuestion size={48} className="text-white bg-[#0a3039] p-3 mt-1 rounded-full" />,
      title: 'Any Questions?',
      btn: 'Make an Enquiry',
      buttonClass: 'text-[#e84c24] border-[#16bab1]',
      buttonWidth: 'w-[120px]',
      
    },
    {
      icon: <FaHome size={48} className="text-white bg-[#0a3039] p-3 mt-1 rounded-full" />,
      title: 'See it yourself!',
      btn: 'Book a Visit',
      buttonClass: 'text-[#e84c24] border-[#16bab1]',
      buttonWidth: 'w-[100px]',
    },
    {
      icon: <FaRegFilePdf size={48} className="text-white bg-[#0a3039] p-3 mt-1 rounded-full" />,
      title: 'Ready to Join?',
      btn: 'Register',
      buttonClass: 'text-[#e84c24] border-[#16bab1]',
      buttonWidth: 'w-[90px]',
    },
  ];

  const handleButtonClick = (title) => {
    setDialogTitle(title);
    setOpenDialog(true);
  };

  
  const handleClose = () => {
    setOpenDialog(false);
    setName('');
    setMobile('');
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Name:', name);
    console.log('Mobile Number:', mobile);
    handleClose(); // Close the dialog after submission
  };
  return (
    <ParallaxProvider>
      <div className="max-w-screen-xl mx-auto px-6 -mt-20">
        <div className="text-[#0a3039]">
          {/* Title  Section */}
          <Parallax translateX={[5, -5]} className='text-[80px] sm:text-[120px] md:text-[150px] lg:text-[240px] lg:pl-28 leading-none'>
            <strong className="">Happy</strong>
          </Parallax>
          

          <div className="relative w-full mt-24">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">

              {/* Left Section */}
              <div className="w-full md:w-[40%] flex justify-center md:justify-end p-4">
              <div className="bg-[#0a3039] h-56 w-[340px] md:w-96  max-w-screen-sm md:max-w-screen-md rounded-3xl relative">
                <img
                  src={top}
                  alt="top"
                  className="absolute h-44 w-44 -top-32 right-24"
                />
                <img
                  src={bottom}
                  alt="bottom"
                  className="absolute h-44 w-44 -bottom-[110px] right-24"
                />

                <Swiper
                  spaceBetween={20}
                  slidesPerView={1}
                  loop={true}
                  navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  }}
                  modules={[Navigation]}
                  className="w-96"
                >
                  {videoLinks.map((video, index) => (
                    <SwiperSlide key={index}>
                      <div className="h-52 ml-2 md:ml-3 mt-2 w-[320px] md:w-[360px] mx-auto rounded-3xl relative flex items-center justify-center">
                        <img
                          src={video.thumbnail}
                          alt={`Video Thumbnail ${index + 1}`}
                          className="absolute inset-0 h-full w-full object-cover rounded-3xl"
                        />
                        <a
                          href={video.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="absolute px-6 py-2 bg-[#16bab1] text-white rounded-lg z-10 transition hover:bg-[#16bab1]"
                        >
                          Watch
                        </a>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>

                {/* Navigation Buttons */}
                <div className="swiper-button-prev text-white absolute left-[-30px] top-[50%] transform -translate-y-1/2 z-10 cursor-pointer"></div>
                <div className="swiper-button-next text-white absolute right-[-30px] top-[50%] transform -translate-y-1/2 z-10 cursor-pointer"></div>
              </div>
            </div>

            {/* Right Section */}
            <div className="w-full md:w-[40%] text-[#16bab1]enter px-4 lg:mt-0 mt-9">
              <h1 className="text-3xl md:text-5xl font-bold mb-4 navbar-link">
                kids. Just watch what parents say.
              </h1>
              <p className="font-sans mb-4">
              We will give the Testimonials soon
              </p>
              <div className="items-center mt-6">
                <button className="px-8 py-2 border border-[#16bab1] text-[#16bab1] rounded-lg transition">
                  Watch all testimonials
                </button>
              </div>
            </div>

            <div className="w-[12%]">
              <img src={parant} alt="" className="h-[400px] absolute lg:right-12 right-0 lg:-bottom-12  md:block  hidden" />
            </div>
            </div>
          </div>
          
          {/* Dynamic Cards Section */}
          {/* <div className="flex justify-around flex-wrap mt-5">
            {cards.map((card, index) => (
              <div
                key={index}
                className="bg-[#ededed] relative h-52 w-72 mt-8 mb-5"
              >
                <div className="bg-white navbar-link p-3 border border-gray-300 h-[200px] w-[280px] absolute">
                  {card.icon}
                  <h2 className="text-3xl mt-8 font-bold text-[#0a3039]">
                    {card.title}
                  </h2>
                  <button
                    onClick={() => handleButtonClick(card.title)}
                    className={`text-sm ${card.buttonClass} border py-1 ${card.buttonWidth} p-2 sensei-text mt-2`}
                  >
                    {card.btn}
                  </button>
                </div>
              </div>
            ))}
          </div> */}
        </div>
        {/* Dialog Component
        <Dialog className='' open={openDialog} onClose={handleClose} maxWidth="md" fullWidth>
          <div className="p-4  ">
            <h2 className="text-xl font-bold">{dialogTitle}</h2>
            <form onSubmit={handleSubmit} className="mt-4">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Mobile Number</label>
                <input
                  type="tel"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                  required
                />
              </div>
              <button type="submit" className="mt-4 px-4 py-2 bg-[#16bab1] text-white rounded">
                Submit
              </button>
              <button onClick={handleClose} className="mt-4 ml-2 px-4 py-2 border border-gray-300 rounded">
                Close
              </button>
            </form>
          </div>
        </Dialog> */}
        
      </div>
    </ParallaxProvider> 
  );
};

export default Happy;